import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useCssMediaQuery = () => {
    const theme = useTheme();
    // xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920
    // md (min-width: 960px)
    const matchesMdup = useMediaQuery(theme.breakpoints.up('md'));
    // sm (max-width:959.95px)
    const matchesMdDown = useMediaQuery(theme.breakpoints.down('sm'));
    // sm, extra-small: (min-width: 600px)
    // xs (max-width: 599.95px)
    const matchesXsDown = useMediaQuery(theme.breakpoints.down('xs'));

    return {
        desktopVersion: matchesMdup,
        mobileVersion: matchesMdDown,
        handyVersion: matchesXsDown
    }
}

export default useCssMediaQuery;